import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { NodeEditorService } from 'src/app/services/node-editor.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit, OnDestroy {
  public mode = 'wiki';
  public sidebarWidth = 240;

  private scrollInterval;
  private subscription: Subscription;

  constructor(private editor: NodeEditorService) {}

  public ngOnInit() {
    this.subscription = this.editor.mode.subscribe(mode => {
      this.mode = mode;
    });
  }

  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public dragEnterDetector(e, dir: number) {
    e.preventDefault();
    if (this.scrollInterval) {
      return;
    }
    this.scrollInterval = setInterval(() => {
      window.scrollBy(0, -dir * 20);
    }, 35);
  }

  public dragExitDetector(e) {
    e.preventDefault();

    clearInterval(this.scrollInterval);
    this.scrollInterval = null;
  }
}
